export default "__VITE_ASSET__BCFvYo2e__"